import { CacheProvider as EmotionCacheProvider } from '@emotion/react'
import emotion_createCache, { Options as CacheOptions } from '@emotion/cache'
import { useServerInsertedHTML } from 'next/navigation'
import { useRef, PropsWithChildren, createElement, useMemo } from 'react'

type EmotionCacheOptions = Partial<CacheOptions>

type CacheProviderProps = PropsWithChildren<EmotionCacheOptions>

const createCache = ((emotion_createCache as any).default ??
  emotion_createCache) as typeof emotion_createCache

function useEmotionCache(options?: EmotionCacheOptions) {
  const isServerInserted = useRef(false)

  const cache = useMemo(() => {
    const cache = createCache({ key: 'css', prepend: true, ...options })
    cache.compat = true
    return cache
  }, [options])

  useServerInsertedHTML(() => {
    if (!isServerInserted.current) {
      isServerInserted.current = true
      return createElement('style', {
        key: cache.key,
        'data-emotion': `${cache.key} ${Object.keys(cache.inserted).join(' ')}`,
        dangerouslySetInnerHTML: {
          __html: Object.values(cache.inserted).join(' '),
        },
      })
    }
  })

  return cache
}

export function CacheProvider({
  children,
  ...cacheOptions
}: CacheProviderProps) {
  return (
    <EmotionCacheProvider value={useEmotionCache(cacheOptions)}>
      {children}
    </EmotionCacheProvider>
  )
}
